import { render, staticRenderFns } from "./dealer.vue?vue&type=template&id=6c8251b6&scoped=true&"
import script from "./dealer.vue?vue&type=script&lang=js&"
export * from "./dealer.vue?vue&type=script&lang=js&"
import style0 from "./dealer.vue?vue&type=style&index=0&id=6c8251b6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6c8251b6",
  null
  
)

export default component.exports